import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api, { formatApiError } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const { data } = await api.get('/auth/me', { validateStatus: s => s < 500 });
            if (data && data.email) setUser(data);
            else setUser(false);
        } catch {
            setUser(false);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { checkAuth(); }, [checkAuth]);

    const login = async (email, password) => {
        try {
            const { data } = await api.post('/auth/login', { email, password });
            setUser(data);
            return { success: true, data };
        } catch (e) {
            return { success: false, error: formatApiError(e.response?.data?.detail) };
        }
    };

    const register = async (formData) => {
        try {
            const { data } = await api.post('/auth/register', formData);
            setUser(data);
            return { success: true, data };
        } catch (e) {
            return { success: false, error: formatApiError(e.response?.data?.detail) };
        }
    };

    const logout = async () => {
        try { await api.post('/auth/logout'); } catch {}
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
